import { PixelColor } from '@/components/PixelAnimation.vue'

export const useAnimationDataPromisesMap = () =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useState<Partial<Record<PixelColor, Promise<any>>>>(
    'animation-data-promises-map',
    () => ({})
  )

export const useAnimationDisabled = () =>
  useState('animation-disabled', (): boolean => false)
